import {GenEmailData} from '../../../generated/serverModels/GenEmailData';

export class EmailData extends GenEmailData {}
